<template>
    <z-basePage :title="'任务浏览'">
        <div class="search-top">
            <span>任务类型</span>
            <el-select class="top-choose" v-model="search.type" clearable>
                <el-option v-for="item in taskTpl" :key="item.id" :value="item.id" :label="item.tpl_name" >
                </el-option>
            </el-select>
            <span>任务状态</span>
            <el-select class="top-choose" v-model="search.status" clearable>
                <el-option v-for="(text,key) in task_status" :key="key" :value="key" :label="text" >
                </el-option>
            </el-select>
            <span>名称/编号</span>
            <el-input class="top-choose" v-model="search.text" placeholder="输入名称或编号"></el-input>
            
            <div class="back-btn blue" @click="searchDoc(1)">搜索</div>
        </div>
        
        <div class="back-list">
            <div class="list-head">
                <div>编号</div>
                <div>发布时间</div>
                <div>任务名称</div>
                <div>发布者</div>
                <div>接收者</div>
                <div>任务类型</div>
                <div>任务快币</div>
                <!-- <div>周期</div> -->
                <div>状态</div>
            </div>
            <z-scrollDiv class="main">
                <div class="list-item"  v-for="item in dataList" :key="item.id">
                    <div class="text-blue" @click="showTask(item)">{{ item.code }}</div>
                    <div>{{ item.release_time | placeholder }}</div>
                    <div class="overhide" :title="item.task_name">{{ item.task_name }}</div>
                    
                    <div class="overhide" 
                    :class="{'text-blue':item.pub_user_name}" 
                    :title="item.pub_user_name"
                    @click="showPerson(item.pub_user_id)"
                    >
                    {{ item.pub_user_name }}
                    </div>

                    <div class="overhide" 
                    :class="{'text-blue':item.sub_user_name}" 
                    :title="item.sub_user_name"
                    @click="showPerson(item.sub_user_id)"
                    >
                    {{ item.sub_user_name || "暂无"}}
                    </div>

                    <div class='overhide' :title="item.tpl_name">{{ item.tpl_name }}</div>
                    <div>{{ item.currency_amount }}</div>
                    <!-- <div>{{ item.task_cycle }}</div> -->
                    <div>{{ task_status[item.process_status] }}</div>
                </div>
                <z-noData :list="dataList"></z-noData>
            </z-scrollDiv>
        </div>

        <el-pagination
            @current-change="searchDoc"
            :current-page.sync="data.current_page"
            :total="data.total"
            :page-size="data.per_page"
            layout="prev, pager, next, jumper"
        ></el-pagination>

        <z-windowPop @cancel="pop.show = false" :show="pop.show" :height="'80%'" :noBtns="true" :title="`任务编号：${pop.title}`">
            <readDetail :taskId="pop.id" :prohibit="true"></readDetail>
        </z-windowPop>

        <!-- 人员信息弹窗 -->
        <personPop :read="true" :id="person.id" :show="person.flag" @close="person.flag = false"></personPop>

    </z-basePage>
</template>

<script>
    import readDetail from "src/components/read-taskDetail.vue";
    import personPop from 'src/components/person-detail/person-pop-info.vue'

    import { mapState } from "vuex"

    export default {
        components:{
            readDetail,
            personPop,
        },
        data(){
            return {
                search:{
                    type:"",
                    text:"",
                    status:"",
                },
                data:{},
                pop:{
                    show:false,
                    title:"",
                    id:"",
                },
                person:{
                    flag:false,
                }
            }
        },
        computed:{
            ...mapState(['taskTpl']),
            ...mapState({
                task_status:function(state){
                    let obj = state.task.task_status;
                    let res = {};
                    for(let i in obj){
                        res = {
                            ...res,
                            ...obj[i][3]
                        }
                    }
                    return res;
                }
            }),
            dataList(){
                return this.data.list;
            },
        },
        created(){
            this.$func.getTaskTpl(true);
            this.getData();
        },  
        methods:{
            getData(obj){  //获取数据
                let url = `api/admin/task/list`;
                let config = {params:obj};
                this.$http.get(url,config).then(res=>{
                    if(res.status == 200){
                        this.data =  res.res_data;
                    }
                });
            },
            searchDoc(page){  //搜索
                page = page == undefined?this.data.current_page:page;
                let obj = {
                    page:page,
                    template_id:this.search.type,
                    status:this.search.status,
                    keyword:this.search.text,
                }
                this.getData(obj);
            },
            showTask(item){
                this.pop.id = item.id;
                this.pop.title = item.code;
                this.pop.show = true;
            },
            showPerson(id){
                this.person.id = id;
                this.person.flag = true;
            },
        }
    }
</script>

<style lang="less" scoped>
	@import "~src/assets/less/backless/var.less";

    .search-top{
        .back-btn{
            position: relative;
            display: inline-block;
            margin-left: 30px;
        }
    }

    
    .back-list{
        margin-top:10px;
        height:calc(~"100% - @{line} - @{search_m} - 10px - @{page_need}");
        // 列表高度
        .main{
            height:calc(~"100% - @{list-head}");
        }
    }
    .list-head,.list-item{
        >div:nth-of-type(1){
            width: 10%;
        }
        >div:nth-of-type(2){
            width: 17%;
        }
        >div:nth-of-type(3){
            width: 13%;
            padding-right: 2%;
        }
        >div:nth-of-type(4){
            width: 12%;
            padding-right: 2%;
        }
        >div:nth-of-type(5){
            width: 12%;
            padding-right: 2%;
        }
        >div:nth-of-type(6){
            width: 10%;
        }
        >div:nth-of-type(7){
            width: 10%;
        }
        >div:last-of-type{
            width: 10%;
        }
    }
</style>





// WEBPACK FOOTER //
// page-task-skim.vue?faad9d86